module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_10X_DCIS.15763ce3.png";